<template>
    <div class="LoginPage">
        <SiteHeader/>

        <Container>
            <h1>Log in</h1>
            <Card>
                <form @submit.prevent="handleLogin">
                    <span v-if="loginError" class="error">{{ loginError }}</span>

                    <FormInput v-model="identity" label="Email"/>
                    <FormInput v-model="password" type="password" label="Password"/>

                    <Button class="primary block" type="submit" :disabled="loginPending">Log In</Button>
                </form>

                <Button to="/login/forgot" class="link block">Forgot your password?</Button>
            </Card>
        </Container>

        <SiteFooter/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Card from '@/components/Card';

export default {
    name: 'LoginPage',

    data: () => ({
        identity: '',
        password: '',
    }),

    computed: mapState('auth', ['loginPending', 'loginError']),

    components: {
        SiteHeader,
        SiteFooter,
        Card,
    },

    methods: {
        handleLogin() {
            const { identity, password } = this;
            this.$store.dispatch('auth/login', { identity, password });
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.LoginPage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        margin-top: 30px;
        margin-bottom: 80px;
        text-align: center;

        h1 {
            @extend %display-subtitle;
            margin-bottom: 30px;
        }
    }

    .Card {
        max-width: 600px;
        margin: 0 auto;
    }

    .SiteFooter {
        align-self: flex-end;
    }

    .info {
        margin-top: 40px;
    }

    .error {
        color: $red-color;
    }
}
</style>
